import classes from './Loading.module.css';

export const Loading = () => (
  <div className={classes.wrapper}>
    <div className={classes.loading}>
      <div className={classes.content}></div>
    </div>
  </div>
);
